import React, { useEffect, memo } from "react";
import usePay from "../hooks/usePay";
import { QRCodeCanvas } from "qrcode.react";
import Modal from "./Modal";
import { openBrowser } from "../common";
import "./styles/scss/MemberPay.scss";

function App(props) {
	const { isShow, onClose } = props;
	const {
		productList,
		product,
		setProduct,
		payType,
		setPayType,
		agree,
		setAgree,
		qrcode,
		time,
		setRefresh,
		paySucc,
	} = usePay({
		isShow,
		onClose,
		from: "MemberPay",
	});

	useEffect(() => {
		if (!paySucc) return;

		Modal.tips({
			icon: "succ",
			contentHead: (
				<p>你已成功购买 【{productList[product]["productName"]}】 大会员</p>
			),
			contentBody: "加速器请前往官网下载使用加速服务",
			onOk: (c) => {
				c();
			},
			cancelBtn: null,
		});
	}, [paySucc, productList, product]);

	return (
		<Modal className="popup-member-pay" visible={isShow} onClose={onClose}>
			<div className="banner"></div>
			<div className="product-list">
				{productList.map((ele, index) => {
					return (
						<div
							key={index}
							className={`product${product === index ? " active" : ""}`}
							onClick={() => {
								setProduct(index);
							}}
						>
							<div>{ele.productName}</div>
							<div>
								{((ele.productPrice / ele.durationPc) * 24).toFixed(1)}元/天
							</div>
							<div>{ele.productPrice}元</div>
							<div>（{ele.originPrice}元）</div>
						</div>
					);
				})}
			</div>
			<div className="pay-list">
				<div className="pay-type">
					{[...new Array(2)].map((ele, index) => {
						return (
							<button
								type="button"
								key={index}
								className={payType === index ? "active" : ""}
								onClick={() => {
									setPayType(index);
								}}
							>
								{ele}
							</button>
						);
					})}
				</div>
				<div className="qrcode">
					<QRCodeCanvas value={qrcode} size={96} />
					<div
						className="shadow"
						style={{ display: agree && time !== 0 ? "none" : "block" }}
					>
						{agree ? (
							<>
								二维码已过期
								<button
									type="button"
									onClick={() => {
										setRefresh((c) => !c);
									}}
								>
									刷新
								</button>
							</>
						) : (
							"请先勾选协议"
						)}
					</div>
				</div>
				<div className="pay-info">
					<div>会员类型：{productList[product]?.["productName"]}</div>
					<div>
						应付金额：
						<span>
							￥<span>{productList[product]?.["productPrice"]}</span>
						</span>
					</div>
					<div>
						<button
							type="button"
							className={agree ? "active" : ""}
							onClick={() => {
								setAgree(!agree);
							}}
						></button>
						<div
							onClick={() => {
								openBrowser("http://www.wanjiayizhan.com/HYUserAgreement");
							}}
						>
							《会员服务协议》
						</div>
						<div
							onClick={() => {
								openBrowser("http://www.wanjiayizhan.com/GXUserAgreement");
							}}
						>
							《共享服务协议》
						</div>
					</div>
				</div>
			</div>
		</Modal>
	);
}

export default memo(App);
